import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import HeroBanner from '../components/HeroBanner';
import './Blog.css';

export default function Blog() {
  // Placeholder blog posts - replace with actual data or API call
  const posts = [
    {
      id: 1,
      title: 'The Benefits of Legal Process Outsourcing for Modern Law Firms',
      excerpt:
        'Discover how LPO can help your firm reduce costs, improve efficiency, and focus on strategic legal work that drives client outcomes.',
      date: 'January 15, 2026',
      category: 'Industry Insights',
    },
    {
      id: 2,
      title: 'How Paralegal Support Improves Personal Injury Case Outcomes',
      excerpt:
        'Learn how professional paralegal services streamline case preparation, evidence organization, and insurer communication for better settlement results.',
      date: 'January 8, 2026',
      category: 'Practice Areas',
    },
    {
      id: 3,
      title: 'Document Review Best Practices in Discovery Proceedings',
      excerpt:
        'Expert guidance on efficient document review workflows that ensure compliance, accuracy, and strategic advantage in litigation.',
      date: 'December 20, 2025',
      category: 'Best Practices',
    },
  ];

  return (
    <>
      <HeroBanner title="Blog" subtitle="Insights, updates, and best practices from Bridge Legal Services" breadcrumb="Blog" />

      <section className="blog-page">
        <div className="container">
          <div className="blog-grid">
            {posts.map((post) => (
              <article key={post.id} className="blog-card">
                <div className="blog-card__meta">
                  <span className="blog-card__category">{post.category}</span>
                  <span className="blog-card__date">{post.date}</span>
                </div>
                <h3>{post.title}</h3>
                <p>{post.excerpt}</p>
                <span className="blog-card__link">
                  Read More <ArrowRight size={16} />
                </span>
              </article>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
